/**
 * Analytics (beta) — the reimagined Engagement + Redirects, one tool for every figure.
 * docs/ANALYTICS-TOOL-DESIGN.md. Built alongside the old tools, which stay until this
 * one has everything they have.
 */
import { FaChartPie } from 'react-icons/fa';
import { BaseTool } from '../BaseTool';

export class AnalyticsTool extends BaseTool {
  constructor() {
    super();
    this.id = 'analytics';
    this.name = 'Analytics (beta)';
    this.description = 'Where visitors come from, what they do, and what it leads to — the website and every link';
    this.icon = FaChartPie;
    // Deep cyan: an identity distinct from Engagement's indigo, and clear of the
    // green/red the pages use to MEAN better/worse.
    this.color = '#0e7490';
    this.path = '/dashboard/tools/analytics';
    // Reads engagement, qr_scans, campaign_labels and the rest; owns nothing.
    this.collections = [];
    this.requiresAdmin = false;
    // Hidden until each person switches it on in their profile — Lee's call, 11 Sep
    // 2026: colleagues should not meet a half-built tool.
    this.hiddenByDefault = true;
  }

  async getSummaryData() {
    return { success: true, data: {}, lastUpdated: new Date() };
  }
}
